<div
  class="sender flex"
  (click)="
    showContextMenu()
      ? contextMenuService.open($event, { userMessage: message() })
      : null
  "
  [style.cursor]="showContextMenu() ? 'pointer' : 'default'"
>
    @if (message().__system) {
        <img class="avatar s-20 flex items-center justify-center" src="assets/images/core/tf2-logo-icon.png"
             alt="TF2Hunt"/>
    } @else {
        <img
                [src]="message().profile.avatar"
                class="avatar s-20 flex items-center justify-center rounded-full"
                alt="steam avatar"
        />
    }

    <app-user-level
    [level]="message().profile.level"
    class="level"
  ></app-user-level>
  @if (message().__system) {
      <div class="name">TF2Hunt</div>
  } @else {
    <div class="name">{{ message().profile.name }}</div>
  }
  @if ((message().profile.admin ?? 0) > 0) {
  <div class="admin button rounded-4 padding-x-6 h-20 button--style-primary">
    {{ ADMIN_LEVELS[(message().profile.admin ?? 0) - 1] }}
  </div>
  }
</div>
@if (isSupplyDropMessage()) {
    <app-supply-drop-message [message]="message()"/>
} @else {
<p
  class="content"
  [innerHTML]="message().content | chatEmote : message().profile.level"
></p>
}
@if (sessionService.is_admin()) {
<div class="admin-buttons flex items-center">
  <button
    class="button rounded-4 h-26 padding-x-4 button--style-white-04 admin-button"
    (click)="clipboardService.copy(message().profile.steamid, 'SteamID copied')"
  >
    Copy SteamID
  </button>
  @for (feature of adminFeatures(); track $index) {
  <!--  -->
  <button
    class="button rounded-4 h-26 padding-x-4 button--style-white-04 admin-button"
    (click)="feature?.action(message())"
  >
    {{ feature.title }}
  </button>
  } @for (badge of messageFeatureBadges(); track $index) {
  <div
    class="button rounded-4 h-26 padding-x-4 button--style-white-04 admin-button cursor-default"
  >
    {{ badge.title }}
  </div>
  }
</div>
}
